export interface Typography {
    logo: {
        fontFamily: string;
    };
    ranking: {
        fontFamily: string;
    };
    h1: {
        fontSize: string;
    };
    h2: {
        fontSize: string;
    };
    h3: {
        fontSize: string;
    };
    h4: {
        fontSize: string;
    };
    h5: {
        fontSize: string;
    };
    h6: {
        fontSize: string;
    };
    fontSize: string;
    fontFamily: string;
    fontWeightLight: number;
    fontWeightRegular: number;
    fontWeightMedium: number;
    fontWeightBold: number;
}

export default {
    logo: {
        fontFamily: 'Josefin Sans',
    },
    ranking: {
        fontFamily: 'Bebas Neue',
    },
    h1: {
        fontSize: '24px',
    },
    h2: {
        fontSize: '21px',
    },
    h3: {
        fontSize: '20px',
    },
    h4: {
        fontSize: '19px',
    },
    h5: {
        fontSize: '18px',
    },
    h6: {
        fontSize: '17px',
    },
    fontSize: '14px',
    fontFamily: 'Nunito',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
};
